import { AUTHOR_TYPES } from "../../../../packages/constants";
import { BotIcon, OperatorIcon } from "../../../../packages/icons";
import { helpers } from "../../../../packages/helpers";
import styles from "./chat-message.module.scss";

const { isAuthorBot, isAuthorOpponent } = helpers.predicates;

type Props = {
  role: AUTHOR_TYPES;
};

export const ChatMessageAvatar = ({ role }: Props) => {
  if (isAuthorBot(role)) {
    return (
      <span data-test-id="chat-message-bot-avatar" className={styles.avatar}>
        <BotIcon />
      </span>
    );
  }

  if (isAuthorOpponent(role)) {
    return (
      <span
        data-test-id="chat-message-opponent-avatar"
        className={styles.avatar}
      >
        <OperatorIcon />
      </span>
    );
  }

  return null;
};
